export enum CompanyHierarchyLocationsWithEmployeeCountEnum {
  you = 'you',
  office = "office",
  country = "country",
  region = "region",
  company = "company",
}

export type CompanyHierarchyLocationsWithEmployeeCount = { [key in CompanyHierarchyLocationsWithEmployeeCountEnum ]?: number }
